export const CATEGORY_WEIGHT_DECIMAL_ACCURACY = 2
export const GRADE_DECIMAL_ACCURACY = 2
export const POINTS_DECIMAL_ACCURACY = 1
